import Navbar from "./components/Navbar"; // adjust path if needed
import Home from "./pages/Home";

function App() {
  return (
    <>
     <section className="hero relative">
  <Navbar />
  <Home />
</section>
    </>
  );
}

export default App;